import { createRangeModule, type RangeSlice } from "../utils/createRangeModule";

/** @deprecated Use RangeSlice instead */
export type RevenueSlice = RangeSlice;

export const revenueModule = createRangeModule({
  key: "revenue",
  apiField: "revenue",
  apiFixedField: "hasFixedRevenue",
  checkboxLabel:
    "Limit to companies with fixed revenue values within this range",
  prefix: "$",
  chipLabel: "Revenue",
  isCurrency: true,
});

export const defaultRevenueSlice = revenueModule.defaultSlice;
